import SwiperGifComponent from "./SwiperGifComponent";

export default SwiperGifComponent;